import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { areaForPath } from "./route";

/**
 * Gives routed page content its area as the outermost tag scope (spec D8), so
 * pages only tag their own elements. `display: contents` keeps it out of layout.
 */
export function PageScope({ children }: { children: ReactNode }) {
  const area = areaForPath(useLocation().pathname) ?? undefined;
  return (
    <div data-ph-scope={area} style={{ display: "contents" }}>
      {children}
    </div>
  );
}
